import BoxLoading from '#/components/box-loading'

export default function Loading() {
  return (
    <main className="fixed inset-0 z-40 flex items-center justify-center text-orchid backdrop-blur bg-orchid/20">
      <BoxLoading />
    </main>
  )
}
